import React from 'react';
import { DiaryEntry } from './DiaryEntry';
export function DiaryEntries() {
  const entries = [{
    date: 'vor 5 Monaten',
    title: 'Das Problem',
    content: 'Bruno pupst ständig. Nach jedem Fressen, abends auf der Couch, nachts im Schlafzimmer. Der Geruch ist kaum auszuhalten. Freunde lachen, aber ich mache mir wirklich Sorgen. Beim Spaziergang kräuseln Fremde die Nase. Bruno wirkt aufgebläht und unwohl. Das kann nicht normal sein.',
    rotation: -1
  }, {
    date: 'vor 4 Monaten',
    title: 'Die Suche',
    content: 'Ich wechsle das Futter. Nichts. Ich probiere Aktivkohle-Snacks. Kurze Besserung, dann wieder dasselbe. Der Tierarzt sagt der Darm sei in Ordnung aber die Darmflora wahrscheinlich unausgeglichen. Er empfiehlt Probiotika – aber die sind teuer und Bruno mag sie nicht. Ich suche weiter.',
    rotation: 1
  }, {
    date: 'vor 3 Monaten',
    title: 'Der Tipp',
    content: 'Beim Gassi gehen erzählt mir eine andere Hundebesitzerin aus unserer Hundegruppe von einem pflanzlichen Futtertopping mit Präbiotika und Ballaststoffen. Sie schwört darauf – ihr Hund hatte genau die gleichen Probleme. "Probier es einfach mal aus", sagt sie. Ich bestelle es noch am selben Abend. Meine Erwartungen sind ehrlich gesagt niedrig.',
    rotation: -0.5
  }, {
    date: 'vor 6 Wochen',
    title: 'Die Wende',
    content: 'Nach einer Woche schleichendem Eingewöhnen merke ich die ersten Unterschiede. Bruno pupst deutlich seltener. Nach zwei Wochen: der Bauch wirkt weniger aufgebläht. Er liegt abends entspannter da. Nach einem Monat: wir schlafen beide besser. Ich kann es kaum fassen.',
    rotation: 1.5
  }, {
    date: 'Heute',
    title: 'Heute',
    content: 'Bruno bekommt jeden Morgen einen kleinen Löffel ins Futter. Es dauert 30 Sekunden. Keine Blähungen mehr. Keine peinlichen Momente. Kein aufgeblähter Bauch. Wir genießen wieder gemeinsame Abende auf der Couch – mit frischer Luft. 🐾',
    rotation: -1
  }];
  return <section className="w-full px-4 py-12 bg-cream-dark/30" data-id="element-51">
      <div className="max-w-4xl mx-auto" data-id="element-52">
        <div className="space-y-8" data-id="element-53">
          {entries.map((entry, index) => <DiaryEntry key={index} date={entry.date} title={entry.title} content={entry.content} rotation={entry.rotation} delay={index * 0.1} data-id="element-54" />)}
        </div>
      </div>
    </section>;
}